import axios from "axios";
import { BASE_URL } from "./appConst";
import { axiosAuth } from "./auth.api";
import { toast } from "sonner";

// register customer 
export const registerCustomer = async (values) => {

    const payload = {
      first_name: values.first_name,
      middle_name: values.middle_name || "",
      last_name: values.last_name,
      phone_no: values.phone_no,
      whatsapp_number: values.whatsapp_number || "",
      email: values.email,
      gender: values.gender,
      address: values.address,
      state: values.state,
      district: values.district,
      city: values.city,
      pin: values.pin,
      password: values.password,
      reffered_by: values.reffered_by,
    };

    const response = await axios.post(`${BASE_URL}/user-registration`, payload);

    return response.data;
};

// get the customer info
export const getCustomerInfo = async () => {
  try {
    const api = axiosAuth();

    const response = await api.get(`${BASE_URL}/customer-info`);

    return response.data;

  } catch (error) {
    console.error(error, "Couldn't get customer info");
    window.location.replace("/signup");
  }
}

// get available free health sessions dates
export const getFreeSessionSlots = async (district) => {
  try {
    const api = axiosAuth();

    const response = await api.get(`${BASE_URL}/get-free-session-slot?page=1&pagesize=1000&district=${district}`);

    return response.data;

  } catch (error) {
    console.error(error, "Couldn't get session slots");
  }
}

// book a free health session
export const bookFreeSession = async (sessionId, customerId) => {

    const api = axiosAuth();

    const response = await api.post(`${BASE_URL}/book-free-session`, {slot: sessionId, customer_id: customerId});

    return response.data;
}

// get booked free health sessions dates and info
export const getBookedSession = async (customerId) => {
    const api = axiosAuth();

    const response = await api.get(
      `${BASE_URL}/customer/sessions/${customerId}?page=1&pagesize=10`
    );

    return response.data;
}

// subscribe to a plan
export const subscribePlan = async (customer_id, service, duration, member) => {
  const api = axiosAuth();

  const response = await api.post(`${BASE_URL}/subscribe`, {
    customer_id: customer_id, 
    service: service, 
    duration: duration, 
    member: member,
  });

  return response.data;
};

// get subscription details for the customer
export const getSubscriptions = async (customerId) => {
  const api = axiosAuth();

  const response = await api.get(`${BASE_URL}/get-subscription/${customerId}`);

  return response.data;
};

// get razorpay payment details
export const getRazorpayPaymentDetails = async (paymentId) => {
  const api = axiosAuth();

  const response = await api.get(
    `${BASE_URL}/payment-details-razorpay/${paymentId}`
  );

  return response.data;
};

// make subscription payment
export const subscriptionPayment = async (customerId, duration, member) => {
  const api = axiosAuth();

  const response = await api.post(`${BASE_URL}/payment-subscription`, {
    customer_id: customerId,
    service: "type1",
    duration: duration,
    member: member,
  });

  return response.data;
}

// contact us 
export const contactUs = async (values) => {

  const api = axiosAuth();

  const response = await api.post(`${BASE_URL}/contact-us`, values);

  return response.data;
}

// email subscription
export const emailSubscription = async (email) => {
  const api = axiosAuth();

  const response = await api.post(`${BASE_URL}/email-subscription`, {email: email});

  return response.data;
}

// add membership
export const addMembership = async (customerId, type, discount) => {
  const api = axiosAuth();

  const response = await api.post(`${BASE_URL}/membership`, {
    customer_id: customerId,
    membership: type,
    discount: discount
  });

  return response.data;
};

// upgrade current membership 
export const upgradeMembership = async (customerId, type, discount) => {
  const api = axiosAuth();

  const response = await api.post(`${BASE_URL}/membership/upgrade`, {
    customer_id: customerId,
    membership: type,
    discount: discount,
  });

  return response.data;
}

// get membership
export const getMembership = async (customerId) => {
  const api = axiosAuth();

  const response = await api.get(`${BASE_URL}/membership/${customerId}`); 

  return response.data;
}

// add member to the subscription plan
export const addMembertoPlan = async (subscriptionId, details) => {
  const api = axiosAuth();

  const response = await api.post(`${BASE_URL}/subscription/member/${subscriptionId}`, {
    first_name: details.first_name,
    middle_name: details.middle_name || "",
    last_name: details.last_name,
    email: details.email,
    phone_no: details.phone_no,
    whatsapp_number: details.whatsapp_number || details.phone_no,
    address: details.address,
    district: details.district,
    pin: details.pin,
    city: details.city,
    state: details.state,
    gender: details.gender,
  });

  return response.data;
}


export const getAddedMembers = async (subscriptionId) => {
  const api = axiosAuth();

  const res = await api.get(`${BASE_URL}/subscription/members/${subscriptionId}`);

  return res.data.data;
};

// upload documents
const uploadFile = async(file) => {
  if (!file) return;
  try {
    const api = axiosAuth();

    const { data } = await api.get(
      `${BASE_URL}/candidate/upload?file=${file.name}`
    );

    const { Key, url } = data.data;

    await axios.put(url, file);

    return Key;
  } catch (error) {
    console.error(error);
  }
}

// jop application
export const applyJob = async(values, customer_id) => {
  const api = axiosAuth();


  const [photoKey, signatureKey] = await Promise.all([
    uploadFile(values.photo),
    uploadFile(values.signature),
  ]);

  if (!photoKey || !signatureKey) {
    throw new Error("File upload failed");
  }

  try {
    const response = await api.post(`${BASE_URL}/candidate/apply`, {
      customer_id: Number(customer_id),
      post: values.post,
      district: values.district || "",
      email: values.email,
      Phone: values.phone,
      WhatsApp: values.whatsapp,
      firstName: values.firstName,
      middleName: values.middleName,
      lastName: values.lastName,
      state: values.state,
      fathersName: values.fathersName,
      mothersName: values.mothersName,
      address: values.address,
      postOffice: values.postOffice,
      city: values.city,
      pincode: values.pincode,
      age: Number(values.age),
      dateOfBirth: values.dateOfBirth,
      gender: values.gender,
      maritalStatus: values.maritalStatus,
      nationality: "Indian",
      higherSecondary: values.hs,
      graduation_other: values.graduation_other,
      graduation: values.graduation,
      masters: values.masters,
      masters_other: values.masters_other,
      otherQualifications: values.otherQualification || "",
      percentage12th: Number(values.percentage12th),
      percentageHighestEducation: Number(values.percentageHighestEducation),
      experience: values.experience || "",
      photo: photoKey,
      signature: signatureKey,
    });

    if(response.data.message.toLowerCase() === "success") {
      return response.data;
    }
  } catch (error) {
    toast.error(error.response.data.message);
    console.error(error, "Failed to submit the form!");
  }
};
// free jop application
export const applyJobFree = async(values, customer_id) => {
  const api = axiosAuth();


  const [photoKey, signatureKey] = await Promise.all([
    uploadFile(values.photo),
    uploadFile(values.signature),
  ]);

  if (!photoKey || !signatureKey) {
    throw new Error("File upload failed");
  }

  try {
    const response = await api.post(
      `${BASE_URL}/application/temporary`,
      {
        customer_id: Number(customer_id),
        post: values.post,
        district: values.district || "",
        email: values.email,
        Phone: values.phone,
        WhatsApp: values.whatsapp,
        firstName: values.firstName,
        middleName: values.middleName,
        lastName: values.lastName,
        state: values.state,
        fathersName: values.fathersName,
        mothersName: values.mothersName,
        address: values.address,
        postOffice: values.postOffice,
        city: values.city,
        pincode: values.pincode,
        age: Number(values.age),
        dateOfBirth: values.dateOfBirth,
        gender: values.gender,
        maritalStatus: values.maritalStatus,
        nationality: "Indian",
        higherSecondary: values.hs,
        graduation_other: values.graduation_other,
        graduation: values.graduation,
        masters: values.masters,
        masters_other: values.masters_other,
        otherQualifications: values.otherQualification || "",
        percentage12th: Number(values.percentage12th),
        percentageHighestEducation: Number(values.percentageHighestEducation),
        experience: values.experience || "",
        photo: photoKey,
        signature: signatureKey,
      }
    );

    if(response.data.message.toLowerCase() === "success") {
      return response.data;
    }
  } catch (error) {
    toast.error(error.response.data.message);
    console.error(error, "Failed to submit the form!");
  }
};

// check offer discount
export const checkDiscount = async () => {
  const api = axiosAuth();

  try {
    const response = await api.get(`${BASE_URL}/candidate/discount`);

    return response.data;
  } catch (error) {
    console.error(error);
  }
};

// get job applications
export const getApplications = async(id) => {
  const api = axiosAuth();

  const response = await api.get(`${BASE_URL}/application/${id}`);

  return response.data;
};


export const bookSession = async (id) => {
  const api = axiosAuth();

  const res = await api.put(`${BASE_URL}/customer/book/${id}`);

  return res.data;
};

export const editCustomer = async (
  customerId,
  values,
) => {
  const api = axiosAuth();

  const payload = {
    id: customerId, 
    ...values
  }

  const res = await api.patch(`${BASE_URL}/customer/edit/${customerId}`, payload);
  
  return res.data;
};